"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const types_1 = require("../types");
class CustomerAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async updateCustomerSubscriptions(customerId, brandId, subscriptions) {
        await this.client.put(`/customers/${customerId}/brands/${brandId}/subscriptions`, subscriptions);
    }
    async updateCustomer(customerId, params) {
        try {
            const data = await this.client.patch(`/customers/${customerId}`, params);
            return {
                data,
            };
        }
        catch (err) {
            if (axios_1.default.isAxiosError(err) &&
                (0, types_1.isErrorWithMessage)(err.response?.data) &&
                err.response?.data.message) {
                return { error: err.response?.data.message };
            }
            throw err;
        }
    }
    async setSource(customerId, brandId, source) {
        const data = await this.client.post(`/customers/${customerId}/brands/${brandId}/source`, { source });
        return data;
    }
    async getPaymentMethods(customerID, locationID) {
        return await this.client.get(`/customers/${customerID}/locations/${locationID}/payment-methods`);
    }
    async updatePaymentMethods(customerID, locationID, newPaymentMethods) {
        return await this.client.put(`/customers/${customerID}/locations/${locationID}/payment-methods`, newPaymentMethods);
    }
    async listCustomers(brandId, { phone }) {
        const data = await this.client.get(`/brands/${brandId}/customers`, {
            phone,
        });
        return data;
    }
    async createCustomer(body) {
        const data = await this.client.post(`/customers`, body);
        return data;
    }
    async updateFirebaseToken({ customerId, brandId, registrationToken, created, }) {
        return await this.client.post(`/customers/${customerId}/brands/${brandId}/fcm-token`, {
            registrationToken,
            created,
        });
    }
    async removeFirebaseToken(customerId, brandId) {
        return await this.client.delete(`/customers/${customerId}/brands/${brandId}/fcm-token`);
    }
}
exports.default = CustomerAPI;
//# sourceMappingURL=index.js.map